import { Wrapper, Paragraph, Links } from './styles';
import SectionHeader from '../../shared/SectionHeader';
import LinkIconButton from '../../shared/LinkIconButton';
import socialLinks, { emailLink } from '../../data/socialLinks';

const Contact = () => {
  return (
    <div id="contact">
      <SectionHeader>Contact</SectionHeader>
      <Wrapper>
        <Paragraph>
          Have any questions about my projects or just want to chat? Feel free
          to reach out. I'll try my best to reply ASAP.
        </Paragraph>
        <Links>
          {[emailLink, ...socialLinks].map((s) => (
            <LinkIconButton key={s.id} href={s.url} target="_blank">
              {s.icon}
            </LinkIconButton>
          ))}
        </Links>
      </Wrapper>
    </div>
  );
};

export default Contact;
